// extracted by mini-css-extract-plugin
export default {"go_back":"GoBack_go_back__0LxRF"};